import styled from 'styled-components'


export const MainContainer = styled.div`

  height:10vh;
  display:flex;
  justify-content:center;
  align-items:center;
  width:intrinsic;
  position:static;
  z-index:2;
`


export const MainContent = styled.div`
  z-index:0;
  max-width:1200px;
  padding:8px 24px;
  display:flex;
  flex-direction:column;
  align-items:center;
`
export const MainH1 = styled.h1`
  color:white;
  font-size:3rem;
  text-align:center;
  font-weight:bold;
  text-shadow: -1px 1px 20px rgba(0, 0, 0, 1)



`
export const MainP1 = styled.p`
  color:white;
  font-size:1.5rem;
  text-align:center;
  max-width:600px;
  text-shadow: -1px 1px 20px rgba(0, 0, 0, 1)



  
`
